module.exports = __webpack_public_path__ + "img/logo_mobile.2b162fdc.png";